// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  caseId: __t.u64().primaryKey().name("case_id"),
  civ: __t.string(),
  aSid: __t.u64().name("a_sid"),
  bSid: __t.u64().name("b_sid"),
  payerSid: __t.u64().name("payer_sid"),
  tier: __t.i32(),
  award: __t.i64(),
  status: __t.string(),
  aAccepts: __t.bool().name("a_accepts"),
  bAccepts: __t.bool().name("b_accepts"),
  text: __t.string(),
  source: __t.string(),
  proposedAt: __t.timestamp().name("proposed_at"),
  coolUntil: __t.timestamp().name("cool_until"),
  resolvedAt: __t.timestamp().name("resolved_at"),
});
